import './src/polyfill-keyboard-event';
import {
  RegisterShortcutHandlerOptions,
  RegisterShortcutOptions,
  ShortcutEvent,
  ShortcutHandler,
} from './src/types';

export type RegisterShortcutHandlerOptions = RegisterShortcutHandlerOptions;
export type RegisterShortcutOptions = RegisterShortcutOptions;
export type ShortcutEvent = ShortcutEvent;
export type ShortcutHandler = ShortcutHandler;
export {
  getKey,
  isArrow,
  isSubmitEvent,
  isForceSubmitEvent,
} from './src/keyboard';
export {
  registerShortcut,
  registerShortcutHandler,
  unregisterShortcut,
  unregisterShortcutHandler,
} from './src/shortcuts';
export { useShortcut, useShortcutHandler } from './src/hooks';
export { Key, Scope } from './src/types';
